import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { LinkButtonContainer, AtlasButtonImg } from './styles';

const OpenLinkInNewWindowButton = ({ linkURL, showButton, isExternal }) => {
  if (isEmpty(linkURL)) return '';
  const title = isExternal ? 'External Link' : 'Open New Window';
  const src = isExternal
    ? '/maps-buttons/enlaceredirigido.svg'
    : '/maps-buttons/abrirnuevapestana.svg';
  const numberOfButtonsLeft = isExternal ? 2 : 1;
  return (
    <LinkButtonContainer
      showButton={showButton}
      target="_blank"
      title={title}
      role="button"
      href={linkURL}
    >
      <AtlasButtonImg
        numberOfButtonsLeft={numberOfButtonsLeft}
        src={src}
        alt={title}
        showButton={showButton}
      />
    </LinkButtonContainer>
  );
};
OpenLinkInNewWindowButton.defaultProps = {
  showButton: true,
  isExternal: false
};

OpenLinkInNewWindowButton.propTypes = {
  linkURL: PropTypes.string.isRequired,
  showButton: PropTypes.bool,
  isExternal: PropTypes.bool
};

export default OpenLinkInNewWindowButton;
